/* Inline newsletter signup: no popup, scroll lock, customer ID or public coupon. */
(() => {
  'use strict';
  const storageKey = 'bw-newsletter20261025';
  const dismissKey = storageKey + '-dismissed';
  const confirmation = 'Wenn deine Adresse für die Neuanmeldung berechtigt ist, erhältst du eine Bestätigungsmail. Prüfe auch deinen Spam-Ordner.';

  function stored(storageName, key) {
    try { return window[storageName].getItem(key) === '1'; } catch (_) { return false; }
  }

  function remember(storageName, key) {
    try { window[storageName].setItem(key, '1'); } catch (_) { /* Signup also works without storage. */ }
  }

  function initialize() {
    document.querySelectorAll('[data-bw-newsletter]').forEach((root) => {
      if (root.dataset.bwNewsletterReady) return;
      root.dataset.bwNewsletterReady = 'true';
      if (stored('localStorage', storageKey) || stored('sessionStorage', dismissKey)) return;

      const form = root.querySelector('[data-newsletter-form]');
      const status = root.querySelector('[data-newsletter-status]');
      const dismiss = root.querySelector('[data-newsletter-dismiss]');
      if (!form || !status || !dismiss) return;
      const email = form.elements.namedItem('email');
      const consent = form.elements.namedItem('consent');
      const website = form.elements.namedItem('website');
      const button = form.querySelector('button[type="submit"]');
      if (!email || !consent || !website || !button) return;
      let busy = false;
      let submitted = false;
      const originalButtonText = button.textContent;

      dismiss.addEventListener('click', () => {
        root.hidden = true;
        remember('sessionStorage', dismissKey);
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || submitted) return;
        if (!form.checkValidity() || !consent.checked) {
          form.reportValidity();
          return;
        }
        busy = true;
        button.disabled = true;
        button.textContent = 'Wird gesendet …';
        form.setAttribute('aria-busy', 'true');
        status.hidden = true;
        status.textContent = '';
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(root.dataset.endpoint, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            redirect: 'error',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ email: email.value.trim(), consent: true, website: website.value.trim() }),
            signal: controller.signal
          });
          if (response.status === 429) throw new Error('rate_limit');
          if (!response.ok) throw new Error('request_failed');
          submitted = true;
          remember('localStorage', storageKey);
          form.hidden = true;
          status.dataset.error = 'false';
          status.textContent = confirmation;
          status.hidden = false;
          status.focus({ preventScroll: true });
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = error.message === 'rate_limit'
            ? 'Bitte warte einen Moment und versuche es später erneut.'
            : 'Die Anmeldung konnte gerade nicht gesendet werden. Bitte versuche es später noch einmal.';
          status.hidden = false;
        } finally {
          window.clearTimeout(timeout);
          busy = false;
          form.removeAttribute('aria-busy');
          if (!submitted) {
            button.disabled = false;
            button.textContent = originalButtonText;
          }
        }
      });
      root.hidden = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
